"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./style.css");
var _googleIcon = _interopRequireDefault(require("../../assets/google-icon.png"));
var _reactRouterDom = require("react-router-dom");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const NicheGoogleLogin = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.Link, {
    to: props.googleAuthUrl,
    className: "google-btn mt1",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: _googleIcon.default,
      alt: "Google",
      className: "google-icon"
    }), props.text]
  });
};
var _default = exports.default = NicheGoogleLogin;